import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

import { determineJournalUrl } from './journal-type.widget.model';

export interface ExtTeamCoachingPopupItem {
    name: string;
    metricName: string;
    pctGoal: number;
    pctTarget: number;
    goalMet: number;
    journalID: number;
    journalTypeID: number;
    daysOld: number;
}

export interface TeamCoachingPopupMetric {
    name: string;
    pctGoal: number;
    pctTarget: number;
    goalMet: boolean;
    isOld: boolean;
    journalUrl: string;
}

export interface TeamCoachingPopupItem {
    name: string;
    metrics: TeamCoachingPopupMetric[];
    focus: TeamCoachingPopupMetric;
}

export interface TeamCoachingPopup {
    items: TeamCoachingPopupItem[];
}

class TeamCoachingPopupItemModelTransformer
    implements
        ModelTransformer<TeamCoachingPopupItem, ExtTeamCoachingPopupItem>
{
    transform(model: ExtTeamCoachingPopupItem): TeamCoachingPopupItem {
        return {
            name: model.name,
            metrics: [],
            focus: null,
        };
    }
}

class TeamCoachingPopupItemModelSetTransformer extends ModelSetTransformer<
    TeamCoachingPopupItem,
    ExtTeamCoachingPopupItem
> {
    protected newTransformer(): ModelTransformer<
        TeamCoachingPopupItem,
        ExtTeamCoachingPopupItem
    > {
        return new TeamCoachingPopupItemModelTransformer();
    }

    transform(model: ExtTeamCoachingPopupItem[]): TeamCoachingPopupItem[] {
        const transformer = this.newTransformer();
        const transformed: TeamCoachingPopupItem[] = [];
        let transformedItem;
        model.forEach((item, index) => {
            if (transformedItem && item.name !== transformedItem.name) {
                transformed.push(transformedItem);
                transformedItem = null;
            }
            if (!transformedItem) {
                transformedItem = transformer.transform(item);
            }
            const metric: TeamCoachingPopupMetric = {
                name: item.metricName,
                pctGoal: item.pctGoal,
                pctTarget: item.pctTarget,
                goalMet: item.goalMet != null && item.goalMet !== 0,
                isOld: item.daysOld > 30, // TODO revise
                journalUrl: determineJournalUrl(
                    item.journalTypeID,
                    item.journalID,
                ),
            };
            transformedItem.metrics.push(metric);
            if (!transformedItem.focus && !metric.goalMet) {
                transformedItem.focus = metric;
            }
            if (index === model.length - 1) {
                transformed.push(transformedItem);
            }
        });
        return transformed;
    }
}

export class TeamCoachingPopupModelTransformer
    implements ModelTransformer<TeamCoachingPopup, ExtTeamCoachingPopupItem[]>
{
    transform(model: ExtTeamCoachingPopupItem[]): TeamCoachingPopup {
        const items = new TeamCoachingPopupItemModelSetTransformer().transform(
            model,
        );
        return {
            items,
        };
    }
}

export function validateTeamCoachingPopup(model: TeamCoachingPopup): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('TeamCoachingPopup not valid');
    }
}
